export type CliplisterStage = {
    aspectRatio?: string;
    height?: string;
    width?: string;
};

export type ViewerConfig = {
    parentId: string;
    assetKey: string;
    backgroundColor: string;
    stage: CliplisterStage;
    withNextButton: boolean;
};

export class CliplisterSettings {
    public static getViewerUrl(): string {
        return `/static-proxy/product-assets/cliplister-player.js`;
    }

    public static buildViewerSettings(config: ViewerConfig) {
        const settings: Record<string, unknown> = {
            parentId: config.parentId,
            customer: 86605,
            assetKeys: [config.assetKey],
            keyType: 10000,
            backgroundColor: config.backgroundColor,
            autoplay: false,
            defaultQuality: 'auto',
            assetLimit: 2,
            stage: config.stage,
            plugins: {
                ClickableVideo: {
                    layer: 1,
                },
                InnerControls: {
                    breakpoints: {
                        s: 447,
                    },
                    layer: 2,
                    id: 'controls',
                    blacklist: ['playback-speed', 'share'],
                    template: {
                        type: 'external',
                        source: 'https://cdn19.mycliplister.com/media019/static/viewer/assets/skins/otto/2018/controls-otto-live.html',
                    },
                },
                BufferingSpinner: {
                    layer: 3,
                },
                PreviewImage: {
                    layer: 4,
                },
                PlayButton: {
                    id: 'playButton',
                    layer: 5,
                    image: 'https://cdn19.mycliplister.com/media019/static/viewer/assets/skins/otto/img/playButton_otto2.png',
                    width: 72,
                    height: 72,
                },
                AutoplayNext: {
                    layer: 7,
                    wait: 5,
                },
            },
        };

        if (config.withNextButton) {
            settings['NextButton'] = {
                layer: 6,
                timeAfterStart: 10,
                timeTillEnd: 10,
                visibility: 'mouseover',
                template: 'https://cdn19.mycliplister.com/media019/static/viewer/assets/skins/otto/2018/next-button-otto.html',
                breakpoints: {
                    s: 447,
                },
                position: {
                    top: 8,
                    right: 8,
                },
            };
        }

        return settings;
    }
}
